import { Button, Flex, Title } from "@qws-org/ui-kit";
import type { FC } from "react";

import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";

import type { StepsProps } from "../Steps";
import { NumberInCircle } from "./NumberInCircle";

export const StepsRow: FC<StepsProps> = (props) => {
  const { data, getUrl, onCallAction, isControlInactive, ...rest } = props;
  const controlAction = data?.action;
  const action = data?.action?.action?.[0];

  let href;
  if (isExternalLink(action?.item)) {
    href = action.item.href ?? undefined;
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }

  const handlePressButton = (): void => {
    if (!controlAction) return;

    const isInactive = isControlInactive(controlAction);
    if (!isInactive) {
      onCallAction(controlAction);
    }
  };
  return (
    <Flex bg="background-accent1" p={{ px: 15 }} {...rest} data-testid="steps">
      <Flex
        flexDirection="column"
        justify="center"
        align="center"
        maxWidth={1240}
        width="100%"
        gap={20}
        p={{ py: 32 }}
        m={{ mx: "auto" }}
        d={{ flexDirection: "row", justify: "space-between" }}
      >
        <Flex
          flexDirection="column"
          flexWrap="wrap"
          align="center"
          gap={24}
          width="100%"
          d={{ flexDirection: "row", justify: "space-around", gap: 16 }}
        >
          {!data.elements &&
            data.steps_items?.map((item, index) => (
              <Flex
                flexDirection="column"
                justify="flex-start"
                align="center"
                key={index}
                gap={8}
                d={{ flexDirection: "row", gap: 16, width: "31%" }}
              >
                <NumberInCircle index={index + 1} />
                <Title
                  as="h4"
                  size="small"
                  horizontalAlign="center"
                  fontWeight="mobile.semibold"
                  fontSize="body.mobile.large"
                  lineHeight="body.desktop.large"
                  md={{
                    fontWeight: "desktop.semibold",
                    fontSize: "body.desktop.large",
                    lineHeight: "body.desktop.large",
                    horizontalAlign: "left",
                  }}
                >
                  {item.text}
                </Title>
              </Flex>
            ))}
          {data.elements?.map((item, index) => (
            <Flex
              flexDirection="column"
              justify="flex-start"
              align="center"
              key={item?.steps_elements_id?.title}
              gap={8}
              d={{ flexDirection: "row", gap: 16, width: "31%" }}
            >
              <NumberInCircle index={index + 1} />
              <Title
                as="h4"
                size="small"
                horizontalAlign="center"
                fontWeight="mobile.semibold"
                fontSize="body.mobile.large"
                lineHeight="body.desktop.large"
                md={{
                  fontWeight: "desktop.semibold",
                  fontSize: "body.desktop.large",
                  lineHeight: "body.desktop.large",
                  horizontalAlign: "left",
                }}
              >
                {item?.steps_elements_id?.title}
              </Title>
            </Flex>
          ))}
        </Flex>
        {data.controls ? (
          data.controls
            ?.filter((control) => {
              if (control?.steps_controls_id?.action) {
                return isControlInactive(control.steps_controls_id.action);
              }
              return true;
            })
            .map((control, idx) => {
              const buttonControlAction = control?.steps_controls_id?.action;
              const buttonAction = buttonControlAction?.action?.[0];
              let buttonHref;
              if (isExternalLink(buttonAction?.item)) {
                buttonHref = buttonAction.item.href ?? undefined;
              }
              if (isInternalLink(buttonAction?.item)) {
                buttonHref = buttonAction.item.page
                  ? getUrl(buttonAction.item.page)
                  : undefined;
              }

              return (
                <Button
                  href={buttonHref}
                  key={control?.id}
                  variant="accent"
                  size="small"
                  fontWeight="desktop.bold"
                  horizontalAlign="center"
                  minWidth={200}
                  maxWidth={280}
                  md={{
                    fontSize: "button.desktop.medium",
                    lineHeight: 'button.desktop.medium"',
                  }}
                  p={{ px: 24, py: 12 }}
                  d={{ p: { py: 18, px: 48 } }}
                  onPress={() => {
                    if (buttonControlAction) {
                      onCallAction(buttonControlAction);
                    }
                  }}
                  data-testid={`steps-control-${idx}`}
                >
                  {control?.steps_controls_id?.text}
                </Button>
              );
            })
        ) : (
          <Button
            href={href}
            variant="accent"
            size="small"
            fontWeight="desktop.bold"
            horizontalAlign="center"
            minWidth={200}
            onPress={handlePressButton}
            maxWidth={280}
            md={{
              fontSize: "button.desktop.medium",
              lineHeight: "button.desktop.medium",
            }}
            p={{ px: 24, py: 12 }}
            d={{ p: { py: 18, px: 48 } }}
            data-testid="steps-control-0"
          >
            {data.action_text}
          </Button>
        )}
      </Flex>
    </Flex>
  );
};
